import { Injectable } from "@angular/core";
import { AdalService, DataStorageService, UtilityService } from '@pulse/common';
import { Observable } from "rxjs";
import { Store } from "@ngrx/store";
import {
  AppConfigService,
  UserService,
  AppDataSharingService,
  StoreOtdsToken,
  IAppState
} from "@pulse/common";
import { OktaAuthService } from './core/oktaauth.service'
import { UserInfo } from "@pulse/common";
import { Constatnts } from "../assets/constants/constants";
import { HttpBackend, HttpClient, HttpHeaders } from "@angular/common/http";
@Injectable({
  providedIn: "root"
})

export class AppLoadService {
  isGetOtdsFirstTime = true;
  environment: string;
  httpClientBackend: any;
  headers: HttpHeaders;
  isInvalidUser: boolean = false;
  constructor(
    private config: AppConfigService,
    private adalService: AdalService,
    private userService: UserService,
    private store: Store<IAppState>,
    private utilityService: UtilityService,
    private oktaAuth: OktaAuthService,
    private appDataSharingService: AppDataSharingService,
    private dataStorageService: DataStorageService,
    private httpBackendHandler: HttpBackend
  ) {
    this.httpClientBackend = new HttpClient(this.httpBackendHandler);
  }

  load(): Promise<void> {
    const BOOTSTRAP_TIMEOUT_MS = 6000;
    
    const initPromise = new Promise<void>((resolve) => {
      this.config.setEnv(this.environment);
      this.config.load().subscribe(
        result1 => {
          this.authenticate().subscribe(
            result2 => {
              resolve();
            },
            err => {
              resolve();
            }
          );
        },
        err => {
          resolve();
        }
      );
    });

    const timeoutPromise = new Promise<void>((resolve) => {
      setTimeout(() => {
        resolve();
      }, BOOTSTRAP_TIMEOUT_MS);
    });

    return Promise.race([initPromise, timeoutPromise]);
  }

  setEnv(env: string) {
    this.environment = env;
  }

  isAuthenticated(): Promise<void> {
    return new Promise(resolve => {
      if (window.location.search.includes('access_denied')) {
        this.isInvalidUser = true;
      }
      if (this.config.get('authType') === 3) {
        this.oktaAuth.isAuthenticatedOkta(resolve);
      } else {
        this.adalService.adalConfigSetup();
        if (!this.config.get("local")) {
          this.adalService.handleLogin().then(() => {
            resolve();
          });

        } else {
          resolve();
        }
      }
    });
  }

  authenticate(): Observable<any> {
    return new Observable(subscriber => {
      this.isAuthenticated().then(result => {
        this.userService.getUserInfoFromAPI().subscribe(
          (userPromise: Promise<any>) => {
            userPromise
              .then((user: UserInfo) => {
                this.handleValidateLoginSuccess(user, subscriber);
              })
              .catch(e => {
                if (e && e.message === "Invalid session id") {
                  this.handleInvalidSession(subscriber);
                } else {
                  subscriber.next(null);
                  subscriber.complete();
                }
              });
          },
          error => {
            subscriber.next(null);
            subscriber.complete();
          }
        );
      });
    });
  }

  handleValidateLoginSuccess(user, subscriber) {
    if (user.email) {
      this.savePulseLog(user);
      this.setSessionInfo(user);
      this.getOtcsTikect();
      localStorage.setItem('VALID_USER_SESSION', 'true');
      setInterval(() => {
        this.getOtcsTikect();
      }, Constatnts.OTDS_INTERVAL_TIME);
    }
    subscriber.next(null);
    subscriber.complete();
  }

  handleInvalidSession(subscriber) {
    try {
      localStorage.clear();
      this.adalService?.login();
    } catch (e) {

    }
    subscriber.next(null);
    subscriber.complete();
  }

  setSessionInfo(user) {
    if (user && user.sessionId) {
      this.dataStorageService.writeToLocalStorage(Constatnts.SESSION_KEY, user.sessionId);
      const date = new Date();
      date.setMinutes(date.getMinutes() + Constatnts.SESSION_MINS);
      this.dataStorageService.writeToLocalStorage(Constatnts.SESSION_EXPIRE, `${date.getTime()}`);
    }
  }

  savePulseLog(userInfo) {
    let sessionID = this.dataStorageService.readFromLocalStorage(Constatnts.SESSION_KEY);
    let sessionExpiry = this.dataStorageService.readFromLocalStorage(Constatnts.SESSION_EXPIRE);

    if (!sessionID || new Date() > new Date(parseInt(sessionExpiry, 10)))
      this.utilityService.savePulseLog(userInfo.userID);

  }

  getOtdsTicket() {
    if (this.isGetOtdsFirstTime) {
      this.store.dispatch(new StoreOtdsToken("loading"));
    }
    this.userService.getOTDSToken().subscribe(data => {
      this.appDataSharingService.setOtdsTicket(data);
      if (this.isGetOtdsFirstTime) {
        this.store.dispatch(new StoreOtdsToken(data));
        this.isGetOtdsFirstTime = false;
      }
    }, (error) => {
      this.store.dispatch(new StoreOtdsToken(null));
    })
  }

  getOtcsTikect() {
    if (this.isGetOtdsFirstTime) {
      this.store.dispatch(new StoreOtdsToken("loading"));
    }
    let otdsToken = this.dataStorageService.readFromLocalStorage(Constatnts.OTDS_TOKEN_KEY);
    let otcsToken = this.dataStorageService.readFromLocalStorage(Constatnts.OTCS_TOKEN_KEY);
    let otdsTokenExpiry = this.dataStorageService.readFromLocalStorage(Constatnts.OTDS_TOKEN_KEY_EXPIRE);

    if (otdsToken && new Date() < new Date(parseInt(otdsTokenExpiry, 10))) {
      this.setOtTokens(otdsToken, otcsToken);
    } else {
      this.userService.getOTCSToken().subscribe((res: any) => {
        if (res && typeof (res) == "string") {
          res = JSON.parse(res);
        }
        this.setOtTokens(res.otdsTicket, res.otcsTiket);
        this.dataStorageService.writeToLocalStorage(Constatnts.OTDS_TOKEN_KEY, res.otdsTicket);
        this.dataStorageService.writeToLocalStorage(Constatnts.OTCS_TOKEN_KEY, res.otcsTiket);
        const date = new Date();
        date.setMinutes(date.getMinutes() + 59);
        this.dataStorageService.writeToLocalStorage(Constatnts.OTDS_TOKEN_KEY_EXPIRE, `${date.getTime()}`);
      }, (error) => {
        this.store.dispatch(new StoreOtdsToken(null));
      })
    }
  }

  setOtTokens(otdsToken, otcsToken) {
    this.appDataSharingService.setOtdsTicket(otdsToken);
    this.appDataSharingService.setOtcsTicket(otcsToken)
    if (this.isGetOtdsFirstTime) {
      this.store.dispatch(new StoreOtdsToken(otdsToken));
      this.isGetOtdsFirstTime = false;
    }
  }


  refreshTokenOnTimer() {
    const key = localStorage.getItem("adal.token.keys");
    this.dataStorageService.writeToLocalStorage(`adal.expiration.key${key.replace(/\|/, "")}`, "0");
    this.adalService.getTokenSilently();
  }
  setSegmentUUID() {
    let email = this.userService?.getUserInfo()?.email;
    if (email) {
      try {
        this.headers = new HttpHeaders();
        this.headers = this.headers.append('Accept', 'text/plain');
        const uri = this.config.get('segmentUUID') + email;
        return this.httpClientBackend.get(uri, { headers: this.headers, responseType: 'text' as 'json' });
      } catch (e) {

      }
    }
  }
}